import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {descriptorDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"

export const downloadFormat = z.union([z.literal("exr"), z.literal("jpg"), z.literal("tiles")])

const descriptorOrChannels = z.union([
    z.object({
        channels: z.number(),
    }),
    z.object({
        descriptor: z.optional(descriptorDefinition),
    }),
])

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.intersection(
            z.object({
                dataObjectId: z.string(),
                downloadFormat: downloadFormat,
            }),
            descriptorOrChannels,
        ),
    },
}
